import { render, staticRenderFns } from "./ThreadListingItem.vue?vue&type=template&id=e60d981a&scoped=true&"
import script from "./ThreadListingItem.vue?vue&type=script&lang=js&"
export * from "./ThreadListingItem.vue?vue&type=script&lang=js&"
import style0 from "./ThreadListingItem.vue?vue&type=style&index=0&id=e60d981a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e60d981a",
  null
  
)

export default component.exports